import { useMemo } from 'react';
import { flattenTree, buildNodeMap } from '../helpers';

export const useHierarchyData = ({ nodes, expandedIds, getNodeKey }) => {
    // Create expanded IDs set for efficient lookup
    const expandedIdsSet = useMemo(() => {
        return new Set(expandedIds);
    }, [expandedIds]);

    // Flatten tree structure
    const flattenedNodes = useMemo(() => {
        if (!nodes || nodes.length === 0) {
            return [];
        }

        return flattenTree(nodes, expandedIdsSet, getNodeKey);
    }, [nodes, expandedIdsSet, getNodeKey]);

    // Build node map for quick lookup
    const nodeMap = useMemo(() => {
        return buildNodeMap(nodes, getNodeKey);
    }, [nodes, getNodeKey]);

    return {
        flattenedNodes,
        nodeMap,
    };
};
